import { useNavigate } from 'react-router-dom';
import { AddUserPage } from '@practium/features/users';

export const AddUserPageAdmin = () => {
	const navigate = useNavigate();

	return (
		<AddUserPage
			id=""
			onBack={() => navigate('/usuarios')}
		/>
	);
};
